import { useAuthStore } from '@/features/auth/auth-store';
import { useAuth } from '@/features/auth/use-auth';
import { ProvisioningBasicForm } from '@/features/provisioning/provisioning-basic-form';
import { useProvisioningQuery } from '@/features/provisioning/provisioning.query';
import { NavDropdown } from '@/shared/components/nav-dropdown';
import {
  Spinner,
  SpinnerFullScreen,
} from '@/shared/components/spinner';
import { useEffect } from 'react';

export function ProvisioningOverlay() {
  const { refreshTokens } = useAuth();
  const { serviceTier, serviceTierStatus } = useAuthStore();
  const { data: provisioning, isLoading } = useProvisioningQuery();

  useEffect(() => {
    if (
      provisioning?.serviceTier === 'PRO' &&
      provisioning?.status === 'READY' &&
      serviceTier === 'PRO' &&
      serviceTierStatus !== 'READY'
    ) {
      void refreshTokens();
    }
  }, [provisioning, serviceTier, serviceTierStatus, refreshTokens]);

  if (isLoading) {
    return <SpinnerFullScreen />;
  }

  const showOverlay =
    !provisioning ||
    provisioning.status === 'PROVISIONING' ||
    provisioning.status === 'DELETION_IN_PROGRESS';

  if (!showOverlay) {
    return null;
  }

  const isProvisioning =
    provisioning?.status === 'PROVISIONING' &&
    provisioning.serviceTier === 'BASIC';
  const isUpgrading =
    provisioning?.serviceTier === 'PRO' &&
    (provisioning.status === 'PROVISIONING' ||
      provisioning.status === 'CHECKOUT_REQUIRED');

  return (
    <div className="bg-background fixed inset-0 z-40 flex flex-col items-center justify-center gap-5">
      <div className="fixed top-5 right-5">
        <NavDropdown />
      </div>

      {!provisioning ? (
        <div className="max-w-[460px]">
          <ProvisioningBasicForm
            context={'BASIC'}
            provisioning={provisioning}
          />
        </div>
      ) : isProvisioning ? (
        <ProvisioningInProgress type="create" />
      ) : isUpgrading ? (
        <ProvisioningInProgress type="update" />
      ) : (
        <ProvisioningInProgress type="delete" />
      )}
    </div>
  );
}

function ProvisioningInProgress({
  type,
}: {
  type: 'create' | 'update' | 'delete';
}) {
  return (
    <>
      <div>
        <div className="text-center text-lg font-bold">
          Ihre Organisation wird{' '}
          {type === 'create'
            ? 'erstellt'
            : type === 'update'
              ? 'auf Pro geupgraded'
              : 'gelöscht'}
          .
        </div>
        <div className="text-muted-foreground text-center text-sm">
          Bitte warten Sie einen Moment.
        </div>
      </div>
      <Spinner className="size-8" />
    </>
  );
}
